//ACCOLADE list
export const ACCOLADE_LIST_REQUEST = 'ACCOLADE_LIST_REQUEST';
export const ACCOLADE_LIST_SUCCESS = 'ACCOLADE_LIST_SUCCESS';
export const ACCOLADE_LIST_FAIL = 'ACCOLADE_LIST_FAIL';
